/** Appearance entropy stays outside simulation state (ADR-080). */
export function parseAppearanceSeed(value: string | null): number | null {
  if (value === null || !/^\d+$/.test(value)) return null;
  const seed = Number(value);
  return Number.isInteger(seed) && seed >= 0 && seed <= 0xffffffff ? seed : null;
}

export function chooseAppearanceSeed(
  explicit: number | null,
  simulationSeed: number,
  controlled: boolean,
  previous: number | null,
  draw: () => number,
): number {
  if (explicit !== null) return explicit;
  if (controlled) return simulationSeed >>> 0;
  const seed = draw() >>> 0;
  return seed === previous ? (seed + 1) >>> 0 : seed;
}
